define([], function() {
    var defaultConfiguration = {
        queryRequired: true,
        queryFieldName: 'query'
    };
    return function(searchTypeConfiguration) {
        return Object.assign({}, defaultConfiguration, searchTypeConfiguration);
    };
});



// WEBPACK FOOTER //
// ./rest/search/searchTypeConfigurationFactory.js